export const getLength = (str: any, len: any) => (
    (str.length > len)
);